<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input style="width: 217px;" v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
            <div class="ml20">
              <el-select filterable  v-model="table.query.communityId" placeholder="请选择小区" clearable @change="search(true)">
                <el-option v-for="item in communities" :key="item.id" :value="item.id"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="名称" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="户号" align="center"
                             prop="code"></el-table-column>
            <el-table-column show-overflow-tooltip label="户型" align="center"
                             prop="type"></el-table-column>
            <el-table-column show-overflow-tooltip label="价格" align="center"
                             prop="price"></el-table-column>
            <el-table-column show-overflow-tooltip label="在租合同" align="center"
                             prop="nowContractDate">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="adminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="密码" align="center"
                             prop="password"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="排序值" align="center"
                             prop="sort"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="410" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="goRoom(scope.row)">房间</el-button>
                <el-button type="text" @click="toHouseOwner(scope.row)">合同明细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="houseDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增房源' : '编辑房源'">
      <el-form ref="houseForm" label-position="right" label-width="120px" :model="houseDialog.formData"
               :rules="rules"  style="height: 550px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="小区：" prop="communityId">
          <el-select filterable  v-model="houseDialog.formData.communityId" placeholder="请选择小区" clearable style="width: 100%;">
            <el-option v-for="item in communities" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="户号：" prop="code">
          <el-input placeholder="请输入户号" v-model="houseDialog.formData.code" clearable/>
        </el-form-item>
        <el-form-item label="户型：" prop="type">
          <el-input placeholder="请输入户型" v-model="houseDialog.formData.type" clearable/>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input placeholder="请输入价格" v-model="houseDialog.formData.price" clearable/>
        </el-form-item>
        <el-form-item label="管理员：" prop="adminId">
          <el-select filterable  v-model="houseDialog.formData.adminId" placeholder="请选择管理员" clearable style="width: 100%;">
            <el-option v-for="item in admins" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input placeholder="请输入密码" v-model="houseDialog.formData.password" clearable/>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="houseDialog.formData.description"></el-input>
        </el-form-item>
        <el-form-item label="排序值：" prop="sort">
          <el-input-number style="width: 100%;" :min="0" v-model="houseDialog.formData.sort"></el-input-number>
        </el-form-item>
        <el-form-item label="房东名：">
          <el-input placeholder="请输入房东名" v-model="houseDialog.formData.ownerName" clearable/>
        </el-form-item>
        <el-form-item label="房东电话：">
          <el-input placeholder="请输入房东电话" v-model="houseDialog.formData.ownerPhone" clearable/>
        </el-form-item>
        <el-form-item label="房东水卡号：">
          <el-input placeholder="请输入房东水卡号" v-model="houseDialog.formData.ownerWaterCard" clearable/>
        </el-form-item>
        <el-form-item label="房东电卡号：">
          <el-input placeholder="请输入房东电卡号" v-model="houseDialog.formData.ownerElectricCard" clearable/>
        </el-form-item>
        <el-form-item label="房东燃气卡号：">
          <el-input placeholder="请输入房东燃气卡号" v-model="houseDialog.formData.ownerGasCard" clearable/>
        </el-form-item>
        <el-form-item label="房东银行卡号：">
          <el-input placeholder="请输入房东银行卡号" v-model="houseDialog.formData.ownerBankCard" clearable/>
        </el-form-item>
        <el-form-item label="证件照片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="houseDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


import {getPageList, deleteData, saveOrUpdateData} from "@/api/house";
import {getList} from "@/api/community";
import {getList as getAdmins} from "@/api/user";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          communityId: '',
          createFrom: 1
        },
        total: 0,
        data: []
      },
      houseDialog: {
        formData: {
          communityId: '',
          communityName: '',
          adminId: '',
          adminName: '',
          price: '',
          type: '',
          code: '',
          name: '',
          imageUrls: '',
          videoUrls: '',
          address: '',
          description: '',
          sort: 0,
          ownerName: '',
          ownerPhone: '',
          ownerWaterCard: '',
          ownerElectricCard: '',
          ownerGasCard: '',
          ownerBankCard: '',
          ownerImageUrls: '',
          password: ''
        },
        visible: false
      },
      rules: {
        communityId: [
          {trigger: 'change', required: true, message: '请选择小区'}
        ],
        adminId: [
          {trigger: 'change', required: true, message: '请选择管理员'}
        ],
        price: [
          {trigger: 'blur', required: true, message: '请输入价格'}
        ],
        type: [
          {trigger: 'blur', required: true, message: '请输入户型'}
        ],
        code: [
          {trigger: 'blur', required: true, message: '请输入户号'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ],
        ownerName: [
          {trigger: 'blur', required: true, message: '请输入房东名'}
        ],
        ownerPhone: [
          {trigger: 'blur', required: true, message: '请输入房东电话'}
        ],
        ownerWaterCard: [
          {trigger: 'blur', required: true, message: '请输入房东水卡号'}
        ],
        ownerElectricCard: [
          {trigger: 'blur', required: true, message: '请输入房东电卡号'}
        ],
        ownerGasCard: [
          {trigger: 'blur', required: true, message: '请输入房东燃气卡号'}
        ],
        ownerBankCard: [
          {trigger: 'blur', required: true, message: '请输入房东银行卡号'}
        ],
        ownerImageUrls: [
          {trigger: 'blur', required: true, message: '请上传证件照片'}
        ],
        password:  [
          {trigger: 'blur', required: true, message: '请输入密码'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      fileList: [],
      communities: [],
      admins: [],
      userInfo: {}
    }
  },
  mounted() {
    let cooperateId = this.$route.query.cooperateId
    if (cooperateId) {
      this.table.query.cooperateId = cooperateId
    }
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.search(true)
    this.getCommunities()
    this.getAdmins()
  },
  methods: {
    // 搜索框查询
    getCommunities() {
      getList().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.communities = response.data
        }
      })
    },
    getAdmins() {
      const params = {
        roleId: '2,5'
      }
      getAdmins(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.admins = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        communityId: this.table.query.communityId,
        createFrom: 1,
        cooperateId: this.table.query.cooperateId
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改房源
    saveOrUpdateData() {
      this.loading = true
      this.$refs['houseForm'].validate(async (valid) => {
        if (valid) {
          if (!this.houseDialog.formData.createPerson) {
            this.houseDialog.formData.createPerson = this.userInfo.nickname
            this.houseDialog.formData.createRole = this.userInfo.roleIds
            this.houseDialog.formData.createFrom = 0
          }
          this.houseDialog.formData.communityName = this.communities.filter(item => item.id == this.houseDialog.formData.communityId)[0].name
          saveOrUpdateData(this.houseDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.houseDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.fileList = []
      if (!isEdit) {
        const communityId = this.houseDialog.formData.communityId
        const communityName = this.houseDialog.formData.communityName
        // 重置数据
        this.houseDialog.formData = {
          communityId: '',
          communityName: '',
          price: '',
          type: '',
          code: '',
          name: '',
          description: '',
          sort: 0,
          ownerName: '',
          ownerPhone: '',
          ownerWaterCard: '',
          ownerElectricCard: '',
          ownerGasCard: '',
          ownerBankCard: '',
          ownerImageUrls: '',
          createPerson: this.userInfo.id,
          createRole: this.userInfo.roleIds,
          createFrom: 0
        }
        if (communityId) {
          this.houseDialog.formData.communityId = communityId
          this.houseDialog.formData.communityName = communityName
        }
      } else {
        if (data.ownerImageUrls) {
          const ownerImageUrls = data.ownerImageUrls.split(',')
          for (let i = 0; i < ownerImageUrls.length; i++) {
            this.fileList.push({
              uid: i,
              url: ownerImageUrls[i]
            })
          }
        }
        this.houseDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.houseDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.houseForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除房源
    deleteData(id) {
      this.$confirm('此操作将永久删除房源信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        url: response.url
      })
      this.houseDialog.formData.ownerImageUrls = this.fileList.map(item => item.url).join(',')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.url != file.url)
      if (this.fileList && this.fileList.length > 0) {
        this.houseDialog.formData.ownerImageUrls = this.fileList.map(item => item.url).join(',')
      } else {
        this.houseDialog.formData.ownerImageUrls = ''
      }
    },
    toDetail(row) {
      this.$router.push('/houseFee?houseId=' + row.id)
    },
    toHouseOwner(row) {
      this.$router.push('/cooperateHouseOwner?houseId=' + row.id)
    },
    toSettlement(row) {
      this.$router.push('/houseSettlement?houseId=' + row.id)
    },
    goRoom(row) {
      this.$router.push('/cooperateRoom?houseId=' + row.id + '&cooperateId=' + this.table.query.cooperateId)
    },
    //导出
    handleExcelExport() {
      window.open("/hrApi/house/export?token=" + localStorage.getItem("token"));
      this.$message.success("导出成功！");
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/cooperateHouse.vue